import React from 'react';
import MvHero from './MvHero';
import MvGenerator from './MvGenerator';
import MvSections from './MvSections';
import './Mv.scss';

export default function Mv() {
  return (
    <div className="mv-page">
      <MvHero />
      <MvGenerator />
      <MvSections />
    </div>
  );
}
